import { gql } from "@apollo/client";

export const SEARCH_USER_BY_EMAIL = gql`
  query searchByEmail($email: String!) {
    searchByEmail(email: $email)
  }
`;
